module dg.clients {

    export interface IClientInfo {
        clientId: string;
        clientName: string;
        clientStatus: string;
        clientLogoFilePath: string;
        clientSmallLogoFilePath: string;
        clientSystemName: string;
        office365TenantUrl: string;
        office365RootUrl: string;
        systemEnv: string;
        /** When true, ECM Data shows Cruise Performance (Report02) export next to diagnostics. */
        useCruisePerformanceReport?: boolean;
    }

    export class ClientInfoService {

        private clientInfo: IClientInfo;
        private pendingClientInfo: ng.IPromise<any>;
        private baseUrl: string;
        //private clientRestService: Restangular.IService;

        public constructor(
            private $q: ng.IQService,
            private $state: ng.ui.IStateService,
            private $http: ng.IHttpService,
            //private Restangular: Restangular.IService,
            private apiSettings: dg.restfulApi.ApiSettings,
            private msalAuthenticationService: any) {

            this.baseUrl = '/api/v' + apiSettings.version;

            //this.clientRestService = Restangular.withConfig((RestangularConfigurer: Restangular.IProvider) => {
            //    RestangularConfigurer.setBaseUrl('/api/v' + apiSettings.version);
            //    RestangularConfigurer.setDefaultHeaders({
            //        accept: 'application/dma+json'
            //    });

            //    RestangularConfigurer.setErrorInterceptor((response, deferred) => {
            //        if (response.status == 403) {
            //            this.adalAuthenticationService.logOut();
            //            //TODO: redirect to state 403 when the server is not returning 403 got html pages
            //            //$state.go('error403');
            //            return false;
            //        }
            //        return true;
            //    });
            //});
        }

        private loadClientInfo(): ng.IPromise<any> {
            //return this.clientRestService.one('client').get();

            return this.$http({
                method: 'GET',
                url: this.baseUrl + '/client'
            });
        }

        public getClientInfo(): ng.IPromise<IClientInfo> {
            var deferred = this.$q.defer<IClientInfo>();
            if (!this.clientInfo) {
                if (!this.pendingClientInfo) {
                    //handles case when more then one request simulteniously calls it
                    this.pendingClientInfo = this.loadClientInfo();
                    this.pendingClientInfo.then(result => {
                        this.clientInfo = result.data.value;
                        this.pendingClientInfo = null;
                    }, (err) => {
                        this.pendingClientInfo = null;
                    });
                }

                this.pendingClientInfo.then(() => {
                    deferred.resolve(this.clientInfo);
                }, deferred.reject);

            } else {
                deferred.resolve(this.clientInfo);
            }
            return deferred.promise;
        }

        public reloadClientInfo(): ng.IPromise<IClientInfo> {
            var deferred = this.$q.defer<IClientInfo>();
            this.loadClientInfo().then(result => {
                this.clientInfo = result.data.value;
                this.pendingClientInfo = null;
                deferred.resolve(this.clientInfo);
            }, (err) => {
                this.pendingClientInfo = null;
                deferred.reject(err);
            });
            return deferred.promise;
        }

        public getClientInfoResolved(): IClientInfo {

            if (angular.isUndefined(this.clientInfo)) {
                throw new Error('IDgClientInfo is not resolved!');
            }
            return this.clientInfo;
        }
    }

    angular.module('dg.clients')
        .service('clientInfoService', ClientInfoService);
}